import { Grid, Flex, FlexItem, Link } from '@gusto/workbench';
import {
  Form,
  SubmitButton,
  TextField,
  SelectField,
  Option,
  Checkbox,
  CheckboxGroup,
} from '@gusto/workbench-formik';
import FormattedPhoneField from 'packages/signup/components/signupForm/formattedPhoneField';
import numberCompaniesBucket from './companies_bucket_values';

const PartnerFormDetails = () => (
  <Grid component={Form} marginBottom={8} rowGap={3}>
    <Flex columnGap={3} rowGap={3} flexDirection="column" flexDirectionMd="row">
      <FlexItem width={1} widthMd={1 / 2}>
        <TextField name="accountant_lead.first_name" type="text" label="First name" required />
      </FlexItem>
      <FlexItem width={1} widthMd={1 / 2}>
        <TextField name="accountant_lead.last_name" type="text" label="Last name" required />
      </FlexItem>
    </Flex>
    <TextField name="accountant_lead.email" type="email" label="Business email address" required />
    <TextField name="accountant_lead.accounting_firm_name" type="text" label="Firm name" required />
    <SelectField
      name="accountant_lead.number_companies_bucket"
      label="No. of business clients"
      required
    >
      <Option value="" />
      {numberCompaniesBucket.map(opt => (
        <Option key={opt.label} value={opt.value}>
          {opt.label}
        </Option>
      ))}
    </SelectField>
    <SelectField
      name="accountant_lead.number_payroll_services_clients_bucket"
      label="No. of payroll services clients"
      required
    >
      <Option value="" />
      {numberCompaniesBucket.map(opt => (
        <Option key={opt.label} value={opt.value}>
          {opt.label}
        </Option>
      ))}
    </SelectField>
    <TextField name="accountant_lead.website" type="text" label="Website" />
    <FormattedPhoneField
      name="accountant_lead.phone"
      label="Phone number"
      type="tel"
      placeholder="(555) 012-3456"
      maxLength={14}
      required
    />
    <CheckboxGroup legend=" " name="terms_acceptance">
      <Checkbox
        label={
          <>
            I accept the{' '}
            <Link href="https://gusto.com/legal/partners" target="_blank">
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link href="https://gusto.com/legal/privacy" target="_blank">
              Privacy Policy
            </Link>
          </>
        }
      />
    </CheckboxGroup>
    <SubmitButton className="btn btn-submit-form">Sign up with email</SubmitButton>
  </Grid>
);

export default PartnerFormDetails;
